import styled from 'styled-components'

export const DownloadImageLink = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 10px;
  a {
    display: block;
    width: 100%;
    img {
      display: block;
      width: 92%;
    }
  }
`
